// extracted by mini-css-extract-plugin
module.exports = {"sorting":"CubesSorting-module__sorting__2MQn4"};